import { ApplicationName } from '../contexts/ApplicationContext';

export interface ApplicationMetadata {
    name: ApplicationName;
    displayName: string;
    version: string;
    versionTag: string;
    description: string;
    color: string;
    gradient: string;
    icon: string;
    loginPath: string;
    badge?: string;
}

export const APPLICATIONS_CONFIG: Record<ApplicationName, ApplicationMetadata> = {
    Planning: {
        name: 'Planning',
        displayName: 'Planning',
        version: '2.4.0',
        versionTag: 'v2.4.0',
        description: 'Gestion des plannings, tâches et ressources.',
        color: '#3b82f6',
        gradient: 'linear-gradient(135deg, #3b82f6, #2563eb)',
        icon: 'fa-calendar-days',
        loginPath: '/Planning/login',
    },
    Maker: {
        name: 'Maker',
        displayName: 'Maker',
        version: '2.1.0',
        versionTag: 'v2.1.0',
        description: 'Conception, projets et suivi de production.',
        color: '#8b5cf6',
        gradient: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
        icon: 'fa-compass-drafting',
        loginPath: '/Maker/login',
    },
    Parc: {
        name: 'Parc',
        displayName: 'Parc Automobile',
        version: '1.8.0',
        versionTag: 'v1.8.0',
        description: 'Gestion de flotte et maintenance des véhicules.',
        color: '#10b981',
        gradient: 'linear-gradient(135deg, #10b981, #059669)',
        icon: 'fa-truck-fast',
        loginPath: '/Parc/login',
    },
    Stock: {
        name: 'Stock',
        displayName: 'Stock & Logistique',
        version: '1.5.0',
        versionTag: 'v1.5.0',
        description: 'Inventaire, mouvements et logistique.',
        color: '#f59e0b',
        gradient: 'linear-gradient(135deg, #f59e0b, #d97706)',
        icon: 'fa-boxes-stacked',
        loginPath: '/Stock/login',
    },
    Academy: {
        name: 'Academy',
        displayName: 'Academy',
        version: '3.2.0',
        versionTag: 'v3.2.0',
        description: "Gestion d'académie, plannings, professeurs et étudiants.",
        color: '#6366f1',
        gradient: 'linear-gradient(135deg, #6366f1, #4f46e5)',
        icon: 'fa-graduation-cap',
        loginPath: '/Academy/login',
        badge: 'Essai gratuit 14j',
    },
    CRM: {
        name: 'CRM',
        displayName: 'CRM & Ventes',
        version: '2.0.0',
        versionTag: 'v2.0.0',
        description: 'Relation client, prospects, opportunités et activités commerciales.',
        color: '#f43f5e',
        gradient: 'linear-gradient(135deg, #f43f5e, #e11d48)',
        icon: 'fa-handshake',
        loginPath: '/CRM/login',
    },
    ProjectManagement: {
        name: 'ProjectManagement',
        displayName: 'Gestion de projet',
        version: '1.2.0',
        versionTag: 'v1.2.0',
        description: 'Portefeuille projets, suivi des tâches, jalons et équipes.',
        color: '#0ea5e9',
        gradient: 'linear-gradient(135deg, #0ea5e9, #0284c7)',
        icon: 'fa-diagram-project',
        loginPath: '/ProjectManagement/login',
    },
};

/**
 * Récupère les métadonnées complètes d'une application par son nom (insensible à la casse)
 */
export const getApplicationConfig = (app: string | null | undefined): ApplicationMetadata | null => {
    if (!app) return null;
    const key = Object.keys(APPLICATIONS_CONFIG).find(
        k => k.toLowerCase() === app.toLowerCase()
    ) as ApplicationName | undefined;
    return key ? APPLICATIONS_CONFIG[key] : null;
};

/**
 * Récupère le numéro de version (avec préfixe 'v') pour une application donnée
 */
export const getApplicationVersion = (app: string | null | undefined, fallback: string = 'v1.0.0'): string => {
    const config = getApplicationConfig(app);
    return config ? config.versionTag : fallback;
};
